import Menus from "../Menus";

const HelpTopicInfoSecurity = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Votre compte', link: '/topics/compte'},
    { label: 'Sécurité du compte', link: '/topics/compte/securite'},
  ]
    
  const multiMenus = [
    {title: null, filter: 'HelpTopicInfoSecurity'},
  ]

  return <Menus goBackLinks={goBackLinks} multiMenus={multiMenus}/>
}

export default HelpTopicInfoSecurity